var alignment_rtlignore_default = {
  "alignLeft": "_2jDbj",
  "textWrapNowrap": "ey83J",
  "alignRight": "_9Eh32",
  "alignCenter": "ZS3PM",
  "sizeFullWidth": "_7b9lp",
  "renderedInTable": "zRemp",
  "sizeOriginal": "QbfYN",
  "sizeContent": "_7EIY5",
  "sizeSmall": "pvtjH",
  "sizeSmallCenter": "HhigS",
  "flex": "_-1hj8",
  "LEFT": "MYedu",
  "CENTER": "STTMh",
  "RIGHT": "mgtIO",
  "AUTO": "_4NVQG",
  "JUSTIFY": "Dj2uy"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
